import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { DialogData } from 'src/app/models/dialog-data';
import { SnackBarService } from 'src/app/services/snack-bar.service';

export interface MeuPerfil {
  noNomeCompleto: string;
  noEmail: string;
  nrCelular: string;
}

class SemEstadoVisualDeErro implements ErrorStateMatcher {
  public isErrorState(): boolean {
    return false;
  }
}

@Component({
  selector: 'app-dialog-meu-perfil',
  templateUrl: './dialog-meu-perfil.component.html',
  styleUrls: ['./dialog-meu-perfil.component.css']
})
export class DialogMeuPerfilComponent implements OnInit, OnDestroy {
  public carregando = true;
  public salvando = false;
  public readonly semEstadoVisualDeErro = new SemEstadoVisualDeErro();
  public perfilForm = new FormGroup({
    noNomeCompleto: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]),
    noEmail: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(80)]),
    nrCelular: new FormControl('', [Validators.pattern(/^$|^\+?\d{0,2}\s?\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/)])
  });

  private subscription?: Subscription;

  public constructor(
    private httpClient: HttpClient,
    private dialogRef: MatDialogRef<DialogMeuPerfilComponent>,
    private dialog: MatDialog,
    private snackBarService: SnackBarService
  ) { }

  public ngOnInit(): void {
    this.carregar();
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public salvar(): void {
    if (this.perfilForm.invalid || this.salvando) {
      this.perfilForm.markAllAsTouched();
      return;
    }

    const valores = this.perfilForm.getRawValue();
    const perfil: MeuPerfil = {
      noNomeCompleto: valores.noNomeCompleto?.trim() ?? '',
      noEmail: valores.noEmail?.trim() ?? '',
      nrCelular: (valores.nrCelular ?? '').replace(/\D/g, '')
    };

    this.salvando = true;
    this.subscription?.unsubscribe();
    this.subscription = this.httpClient.put<MeuPerfil>('/api/Usuarios/MeuPerfil', perfil).subscribe({
      next: resposta => {
        this.salvando = false;
        this.snackBarService.exibirSucesso('Dados do usuário atualizados com sucesso!');
        this.dialogRef.close(resposta);
      },
      error: erro => {
        this.salvando = false;
        this.snackBarService.exibirErro(
          erro?.error?.message ?? 'Não foi possível atualizar os dados do usuário.'
        );
      }
    });
  }

  public cancelar(): void {
    if (this.salvando) {
      return;
    }

    if (this.perfilForm.pristine) {
      this.dialogRef.close();
      return;
    }

    const data: DialogData = {
      title: 'Confirma',
      message: 'Existem alterações pendentes. Deseja descartá-las?',
      buttonText: 'Continuar editando',
      secondButtonText: 'Descartar'
    };

    this.dialog.open(DialogComponent, { data, autoFocus: false })
      .afterClosed()
      .subscribe(descartar => {
        if (descartar) {
          this.dialogRef.close();
        }
      });
  }

  private carregar(): void {
    this.subscription = this.httpClient.get<MeuPerfil>('/api/Usuarios/MeuPerfil').subscribe({
      next: perfil => {
        this.perfilForm.setValue({
          noNomeCompleto: perfil.noNomeCompleto,
          noEmail: perfil.noEmail,
          nrCelular: perfil.nrCelular ?? ''
        });
        this.perfilForm.markAsPristine();
        this.carregando = false;
      },
      error: () => {
        this.carregando = false;
        this.snackBarService.exibirErro('Não foi possível carregar os dados do usuário.');
        this.dialogRef.close();
      }
    });
  }
}
